import React, { useState, useEffect } from 'react';
import './index.css';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BulkEditPanelProps, CartConfiguration, CartType } from '../../../../redux/cartConfigurationSlice';
import { useLazyGetCartTypesQuery } from "../../../../redux/services/DistributionService";

const BulkEditPanel: React.FC<BulkEditPanelProps> = ({
  selectedCarts,
  setBulkEditMode,
  bulkUpdateCarts,
  availableGates,
  isUpdating = false
}) => {
  const [getCartTypes, { data: cartTypesData }] = useLazyGetCartTypesQuery();
  const [cartTypes, setCartTypes] = useState<CartType[]>([]);

  // Fetch cart types on component mount
  useEffect(() => {
    getCartTypes();
  }, [getCartTypes]);

  // Update cart types when data is available
  useEffect(() => {
    if (cartTypesData?.cartTypesList) {
      setCartTypes(cartTypesData.cartTypesList);
    }
  }, [cartTypesData]);

  const [bulkData, setBulkData] = useState({
    priority: '',
    assignedGate: '',
    cartType: ''
  });

  const handleBulkApply = () => {
    // Validate that at least one field is selected
    if (!bulkData.priority && !bulkData.assignedGate && !bulkData.cartType) {
      alert("Please select at least one field to update");
      return;
    }
    
    bulkUpdateCarts(bulkData);
  };

  return (
    <div className="bulk-edit-panel">
      <div className="bulk-edit-header">
        <h3>Bulk Edit Mode ({selectedCarts.size} selected)</h3>
        <button 
          onClick={() => setBulkEditMode(false)} 
          className="btn-secondary-bulkedit"
          disabled={isUpdating}
        >
          Cancel
        </button>
      </div>
      
      <div className="bulk-edit-form">
        <div className="form-group">
          <label>Priority</label>
          <select
            value={bulkData.priority}
            onChange={(e) => setBulkData(prev => ({ ...prev, priority: e.target.value }))}
            disabled={isUpdating}
          >
            <option value="">Select Priority (Optional)</option>
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Gate</label>
          <select
            value={bulkData.assignedGate}
            onChange={(e) => setBulkData(prev => ({ ...prev, assignedGate: e.target.value }))}
            disabled={isUpdating}
          >
            <option value="">Select Assigned Gate (Optional)</option>
            {availableGates.map(gate => (
              <option key={gate} value={gate}>{gate}</option>
            ))}
          </select>
        </div>
        
        <div className="form-group">
          <label>Cart Type</label>
          <select
            value={bulkData.cartType}
            onChange={(e) => setBulkData(prev => ({ ...prev, cartType: e.target.value }))}
            disabled={isUpdating}
          >
            <option value="">Select Cart Type (Optional)</option>
            {cartTypes.map(type => (
              <option key={type.displayName} value={type.displayName}>
                {type.displayName}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <button 
        onClick={handleBulkApply} 
        className="btn-primary-bulkedit"
        disabled={isUpdating || (!bulkData.priority && !bulkData.assignedGate && !bulkData.cartType)}
      >
        {isUpdating ? "Applying..." : "Apply to Selected Carts"}
      </button>
    </div>
  );
};

export default BulkEditPanel;